import { __assign, __awaiter, __extends, __generator } from "tslib";
import React from 'react';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { PnmacPaperLess, PnmacModal, LocalStorage } from 'pnmac-universal-components';
import { UPDATE_LOAN_PREF } from '../../redux/actions/actions.js';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import { Platform, View } from 'react-native';
import EDisbursementPopups from './eDisbursementPopup.js';
var PaperLess = /** @class */function (_super) {
  __extends(PaperLess, _super);
  function PaperLess(props) {
    var _this = _super.call(this, props) || this;
    _this.closeEdisbursementPopup = function () {
      _this.setState({
        eDisbOpen: false
      });
    };
    _this.closePaperlessPopup = function () {
      _this.setState({
        open: false
      });
    };
    _this.updateCallBack = function (_a) {
      var object = _a.object;
      var _b = _this.props.layout,
        selectedLoanNumber = _b.selectedLoanNumber,
        pennyHomeUrl = _b.pennyHomeUrl;
      if (object === null || object === void 0 ? void 0 : object.find(function (s) {
        return s.preferenceTypeCode == 300009 && s.changed == true;
      })) {
        ///monthly sign u[p]
        _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.NavBar, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Loans Signed Up Monthly", 0);
      }
      if (object === null || object === void 0 ? void 0 : object.find(function (s) {
        return s.preferenceTypeCode == 300010 && s.changed == true;
      })) {
        ///yearly sign u[p]
        _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.NavBar, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Loans Signed Up Year End", 0);
        // display eDisbursement popup
        if (_this.props.layout.banksToAdd.length >= 0 && !_this.props.layout.banksToAdd.find(function (e) {
          return e.isEDisbursementAccount;
        })) {
          _this.setState({
            eDisbOpen: true
          });
        }
      }
      _this.setState({
        monthly: false
      }, function () {
        _this.props.dispatch({
          type: UPDATE_LOAN_PREF,
          selectedLoanPreference: object
        });
      });
      object.forEach(function (s) {
        return s.loanId = selectedLoanNumber;
      });
      if (parseInt(selectedLoanNumber) > 0) {
        return fetch("".concat(pennyHomeUrl, "api/loan/update_loan_preferences"), {
          method: 'POST',
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer ".concat(_this.props.layout.token)
          },
          body: JSON.stringify(object)
        });
      }
      return new Promise(function (res, rej) {
        res("aaa");
      });
    };
    _this.state = {
      open: false,
      stat: {
        yearEnd: false,
        monthEnd: false
      },
      monthly: false,
      trackerFlag: false,
      eDisbOpen: false
    };
    return _this;
  }
  PaperLess.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var selectedLoanPreference, stat, i, dpref;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!window.alreadyseen) return [3 /*break*/, 7];
            selectedLoanPreference = this.props.layout.selectedLoanPreference;
            stat = {
              yearEnd: false,
              monthEnd: false
            };
            for (i = 0; i < selectedLoanPreference.length; i++) {
              if (selectedLoanPreference[i].preferenceTypeCode == 300009 && selectedLoanPreference[i].preferenceCode == 300027) {
                stat.monthEnd = true;
              }
              if (selectedLoanPreference[i].preferenceTypeCode == 300010 && selectedLoanPreference[i].preferenceCode == 300027) {
                stat.yearEnd = true;
              }
            }
            return [4 /*yield*/, LocalStorage.getDataObject("PaperLessCount")];
          case 1:
            dpref = _a.sent();
            if (!!dpref) return [3 /*break*/, 3];
            return [4 /*yield*/, LocalStorage.storeDataObject("PaperLessCount", {
              notNow: 0,
              loadCount: 0
            })];
          case 2:
            _a.sent();
            this.setState({
              open: !stat.yearEnd || !stat.monthEnd,
              stat: stat,
              monthly: !stat.monthEnd
            });
            return [3 /*break*/, 4];
          case 3:
            if (parseInt(dpref.loadCount) % 2 == 0) {
              this.setState({
                open: !stat.yearEnd || !stat.monthEnd,
                stat: stat,
                monthly: !stat.monthEnd
              });
            }
            _a.label = 4;
          case 4:
            if (!dpref) return [3 /*break*/, 6];
            return [4 /*yield*/, LocalStorage.storeDataObject("PaperLessCount", {
              notNow: dpref.notNow,
              loadCount: dpref.loadCount + 1
            })];
          case 5:
            _a.sent();
            _a.label = 6;
          case 6:
            window.alreadyseen = true;
            _a.label = 7;
          case 7:
            return [2 /*return*/];
        }
      });
    });
  };
  PaperLess.prototype.render = function () {
    var _this = this;
    var selectedLoanPreference = this.props.layout.selectedLoanPreference;
    var _a = this.props,
      translations = _a.translations,
      matches = _a.matches,
      layout = _a.layout;
    var _b = this.state,
      open = _b.open,
      stat = _b.stat,
      monthly = _b.monthly;
    return /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React.createElement(PnmacModal, {
      open: open,
      isVisible: open
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        height: Platform.OS === 'ios' ? monthly === true ? "55%" : "35%" : Platform.OS === 'android' ? monthly === true ? "70%" : "45%" : "auto",
        alignSelf: layout.mobile ? "flex-start" : "center",
        justifyContent: "center",
        width: matches.small ? "100%" : matches.medium ? "50%" : "30%",
        outline: "transparent"
      }
    }, /*#__PURE__*/React.createElement(PnmacPaperLess, {
      closeModal: function (data) {
        return __awaiter(_this, void 0, void 0, function () {
          var pref;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!data) return [3 /*break*/, 3];
                ///not now
                if (data.section == "monthly") {
                  ///Send monthly
                  this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.NavBar, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Loans Not Now Monthly", 0);
                } else if (data.section == "yearly") {
                  ///Send yearly
                  this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.NavBar, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Loans Not Now Year End", 0);
                }
                // display eDisbursement popup
                if (this.props.layout.banksToAdd.length >= 0 && !this.props.layout.banksToAdd.find(function (e) {
                  return e.isEDisbursementAccount;
                })) {
                  this.setState({
                    eDisbOpen: true
                  });
                }
                return [4 /*yield*/, LocalStorage.getDataObject("PaperLessCount")];
              case 1:
                pref = _a.sent();
                if (!pref) return [3 /*break*/, 3];
                return [4 /*yield*/, LocalStorage.storeDataObject("PaperLessCount", {
                  notNow: pref.notNow + 1,
                  loadCount: pref.loadCount
                })];
              case 2:
                _a.sent();
                _a.label = 3;
              case 3:
                this.setState({
                  open: false
                });
                return [2 /*return*/];
            }
          });
        });
      },
      updateCallBack: function (data) {
        return _this.updateCallBack(data);
      },
      monthly: monthly,
      loanPreference: selectedLoanPreference,
      translations: translations,
      paperlessStatus: stat
    }))), /*#__PURE__*/React.createElement(PnmacModal, {
      open: this.state.eDisbOpen
    }, /*#__PURE__*/React.createElement(EDisbursementPopups, {
      matches: matches,
      closePaperlessPopup: this.closePaperlessPopup,
      closeEdisbursementPopup: this.closeEdisbursementPopup
    })));
  };
  return PaperLess;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(PaperLess);